// Styleguide label
// ================

import React from 'react'
import PropTypes from 'prop-types'
import style from './label.scss'
import cx from 'classnames'
import FieldSize, {
  fieldSizePropTypes,
  fieldSizeDefaultProps,
} from './fieldsize'

const SubLabel = (props) => {
  if (React.Children.count(props.children) === 0) {
    return null
  }

  return (
    <label
      className={cx(props.className, {
        [style.SubLabelSmall]: props.size === FieldSize.SMALL,
        [style.SubLabel]: props.size === FieldSize.DEFAULT,
      })}
      data-description
    >
      {props.children}
    </label>
  )
}

SubLabel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

SubLabel.defaultProps = {
  ...fieldSizeDefaultProps,
}

const Label = (props) => {
  if (React.Children.count(props.children) === 0) {
    return null
  }

  return (
    <div className={style.labelWrapper}>
      <label
        className={cx(
          style.Label,
          {
            [style.LabelSmall]: props.size === FieldSize.SMALL,
            [style.LabelDefault]: props.size === FieldSize.DEFAULT,
          },
          props.className
        )}
        onClick={props.onClick}
        htmlFor={props.for}
      >
        <div className={style.labelContent}>{props.children}</div>
      </label>
      {props.tooltip}
    </div>
  )
}

Label.propTypes = {
  ...fieldSizePropTypes,
  className: PropTypes.string,
  onClick: PropTypes.func,
  for: PropTypes.string,
  children: PropTypes.node,
  tooltip: PropTypes.node,
}

Label.defaultProps = {
  ...fieldSizeDefaultProps,
}

export { SubLabel }
export default Label
